import { Mail, Phone } from "lucide-react";
import ContactForm from "../../components/marketing/ContactForm";
import Breadcrumbs from "../../components/marketing/Breadcrumbs";
import { useSeo } from "../../components/marketing/Seo";

export default function ContactPage() {
  useSeo({ title: "Contact", description: "Start an advisory discussion with CLYMACO across EPR, solid waste, bulk waste generators, circular economy, CSR or client technology.", path: "/contact" });
  return (
    <main id="main" className="bg-parchment-base pt-36" data-testid="contact-page">
      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6">
        <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Contact" }]} />
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]">
        <div>
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-forest-primary">Let's talk</div>
          <h1 className="mt-4 font-display text-5xl font-medium tracking-tight text-forest-deep sm:text-6xl">What needs to work better?</h1>
          <p className="mt-5 text-lg leading-relaxed text-forest-deep/65">Your compliance, your site's waste system, a municipal programme, a circularity project or a technology walkthrough. Tell us the challenge and we will discuss an appropriate scope.</p>
          <div className="mt-10 space-y-4">
            <a href="mailto:alik@clymaco.com" className="flex items-center gap-4 rounded-2xl border border-forest-deep/10 bg-white p-5 text-forest-deep transition-colors hover:border-forest-primary/30" data-testid="contact-email-link">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-forest-primary/10 text-forest-primary"><Mail className="h-5 w-5" /></span>
              <span><span className="block text-xs font-semibold uppercase tracking-widest text-forest-deep/45">Email</span><span className="font-display text-lg font-bold">alik@clymaco.com</span></span>
            </a>
            <a href="tel:+918240968144" className="flex items-center gap-4 rounded-2xl border border-forest-deep/10 bg-white p-5 text-forest-deep transition-colors hover:border-forest-primary/30" data-testid="contact-phone-link">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-forest-primary/10 text-forest-primary"><Phone className="h-5 w-5" /></span>
              <span><span className="block text-xs font-semibold uppercase tracking-widest text-forest-deep/45">Advisory desk</span><span className="font-display text-lg font-bold">+91 8240968144</span></span>
            </a>
          </div>
        </div>
        <ContactForm />
        </div>
      </section>
    </main>
  );
}
